
import { Component, Prop, Vue } from 'vue-property-decorator';
import VueAvatar from 'vue-avatar';
import { State } from 'vuex-class';
import { TenantResource } from '@/api/requests/tenant/types';

@Component({
    components: { VueAvatar },
})
export default class AppAvatar extends Vue {
    @State tenant!: TenantResource;

    @Prop({ type: Number, default: 40 })
    readonly size!: number;
}
